// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"002abaf9","151":"23e7aeaa","161":"c93e02ba","209":"e1f55257","478":"9faeb4a3","625":"03837119","675":"56ea9de9","745":"7f14da62","922":"a9748d02","964":"df209d3d"}[chunkId] + ".chunk.js";
};